module.exports = __webpack_public_path__ + "79e2ca17b71bd97f01bc6e3dfd4fda0b.MP3";